import React from 'react';
export var RumComponentContext = React.createContext({
    componentBreadCrumbs: 'root',
    component: 'root'
});
//# sourceMappingURL=rum-component-context.js.map